import { Observable } from '../Observable';
import { createOperatorSubscriber } from './OperatorSubscriber';
export function isEmpty() {
    return function (source) {
        return new Observable(function (subscriber) {
            source.subscribe(createOperatorSubscriber(subscriber, function () {
                subscriber.next(false);
                subscriber.complete();
            }, function () {
                subscriber.next(true);
                subscriber.complete();
            }));
        });
    };
}
//# sourceMappingURL=isEmpty.js.map